import React, { useState } from 'react';
import Sidebar from './Sidebar';
import bedroomImg from '../assets/bedroom.png';
import livingImg from '../assets/living.png';
import kitchenImg from '../assets/kitchen.png';
import bathroomImg from '../assets/bathroom.png';
import aromaImg from '../assets/aroma.png';
import airImg from '../assets/air.png';
import humiImg from '../assets/humi.png';
import speakerImg from '../assets/speaker.png';
import lampImg from '../assets/smartlamp.png';

const SpaceMap = ({ isVisible, onBack, onLogout, onRoomClick, onNavClick }) => {
  const [viewMode, setViewMode] = useState('map'); // 'map' or 'list'

  if (!isVisible) return null;

  // Dữ liệu rooms
  const rooms = [
    { id: 1, name: 'Bedroom', icon: '🛏️', deviceCount: 3 },
    { id: 2, name: 'Living room', icon: '🛋️', deviceCount: 4 },
    { id: 3, name: 'Bathroom', icon: '🛁', deviceCount: 2 },
    { id: 4, name: 'Kitchen', icon: '🍳', deviceCount: 1 },
  ];

  // Hàm lấy hình ảnh phòng
  const getRoomImage = (roomName) => {
    const roomLower = roomName.toLowerCase();
    if (roomLower.includes('bedroom')) return bedroomImg;
    if (roomLower.includes('living')) return livingImg;
    if (roomLower.includes('kitchen')) return kitchenImg;
    if (roomLower.includes('bathroom')) return bathroomImg;
    return null;
  };

  // Hàm lấy hình ảnh thiết bị
  const getDeviceImage = (name) => {
    if (name.includes('Lamp')) return lampImg;
    if (name.includes('Speaker')) return speakerImg;
    if (name.includes('Aroma')) return aromaImg;
    if (name.includes('Humidifier')) return humiImg;
    if (name.includes('Air Conditioner')) return airImg;
    return null;
  };

  // Dữ liệu devices
  const devices = [
    { id: 1, name: 'Smart Lamp', room: 'Living Room', image: '💡', color: '#93c5fd' },
    { id: 2, name: 'Aroma Diffuser', room: 'Living Room', image: '🌬️', color: '#ffffff' },
    { id: 3, name: 'Air Conditioner', room: 'Living Room', image: '❄️', color: '#ffffff' },
    { id: 4, name: 'Speaker', room: 'Living Room', image: '🔊', color: '#ffffff' },
    { id: 5, name: 'Smart Lamp', room: 'Bedroom', image: '💡', color: '#1f2937' },
    { id: 6, name: 'Speaker', room: 'Bedroom', image: '🔊', color: '#ffffff' },
    { id: 7, name: 'Humidifier', room: 'Bathroom', image: '💧', color: '#ffffff' },
    { id: 8, name: 'Smart Lamp', room: 'Bathroom', image: '💡', color: '#93c5fd' },
    { id: 9, name: 'Smart Lamp', room: 'Kitchen', image: '💡', color: '#93c5fd' },
    { id: 10, name: 'Aroma Diffuser', room: 'Living Room', image: '🌬️', color: '#ffffff' },
    { id: 11, name: 'Speaker', room: 'Living Room', image: '🔊', color: '#ffffff' },
    { id: 12, name: 'Air Conditioner', room: 'Bedroom', image: '❄️', color: '#ffffff' },
  ];

  return (
    <div className="dashboard-container">
      <Sidebar activeId="spaces" onLogout={onLogout} onNavClick={onNavClick} />

      <div className="main-content dashboard-scroll">
        {/* Header Section */}
        <div className="dashboard-header">
          <div className="header-left">
            <button className="back-btn-header" onClick={onBack}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
            </button>
            <h1 className="dashboard-title">My Home</h1>
          </div>
          <div className="header-right">
            <div className="space-selector">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              </svg>
              <span>My Home</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
          </div>
        </div>

        {/* View Toggle */}
        <div className="view-toggle-container">
          <div className="view-toggle">
            <button 
              className={`view-toggle-btn ${viewMode === 'map' ? 'active' : ''}`}
              onClick={() => setViewMode('map')}
            >
              Map view
            </button>
            <button 
              className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
            >
              List view
            </button>
          </div>
        </div>

        {/* Info Cards */}
        <div className="info-cards-grid">
          <div className="info-card weather">
            <div className="info-icon">⛅</div>
            <div className="info-content">
              <div className="info-label">Partly Cloudy</div>
              <div className="info-value">23°</div>
            </div>
          </div>
          <div className="info-card humidity">
            <div className="info-icon">💧</div>
            <div className="info-content">
              <div className="info-label">Humidity</div>
              <div className="info-value">67%</div>
            </div>
          </div>
          <div className="info-card lights">
            <div className="info-icon">💡</div>
            <div className="info-content">
              <div className="info-label">All lights on</div>
              <div className="info-value">Home</div>
            </div>
          </div>
          <div className="info-card music">
            <div className="info-icon">🎵</div>
            <div className="info-content">
              <div className="info-label">Play music</div>
              <div className="info-value">Living room</div>
            </div>
          </div>
        </div>

        {/* Your Rooms Section */}
        <div className="rooms-section">
          <div className="section-header">
            <h2 className="section-title">Your Rooms</h2>
            <span className="section-badge">{rooms.length}</span>
          </div>
          <div className="rooms-grid">
            {rooms.map((room) => (
              <div 
                key={room.id} 
                className="room-card"
                onClick={() => onRoomClick && onRoomClick(room.name)}
                style={{ cursor: 'pointer' }}
              >
                <div className="room-icon-wrapper">
                  {getRoomImage(room.name) ? (
                    <img 
                      src={getRoomImage(room.name)} 
                      alt={room.name} 
                      style={{
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                        borderRadius: '12px'
                      }} 
                    />
                  ) : (
                    <span className="room-emoji">{room.icon}</span>
                  )}
                </div>
                <div className="room-info">
                  <h3 className="room-name">{room.name}</h3>
                  <p className="room-devices">{room.deviceCount} devices</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Devices Section */}
        <div className="devices-section">
          <div className="section-header">
            <h2 className="section-title">Devices</h2>
            <span className="section-badge">{devices.length}</span>
          </div>
          <div className="devices-scroll-container">
            <div className="devices-scroll-list">
              {devices.map((device) => (
                <div key={device.id} className="device-scroll-card">
                  <div className="device-image-wrapper" style={{ backgroundColor: device.color }}>
                    {getDeviceImage(device.name) ? (
                      <img src={getDeviceImage(device.name)} alt={device.name} style={{width: '100%', height: '100%', objectFit: 'contain', padding: '8px'}} />
                    ) : (
                      <span className="device-image-emoji">{device.image}</span>
                    )}
                  </div>
                  <div className="device-scroll-info">
                    <h4 className="device-scroll-name">{device.name}</h4>
                    <p className="device-scroll-room">{device.room}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpaceMap;

